import React, { useEffect, useState } from "react";
import "./doctor-retention.css";
import { Loader } from "../../components";
import { getDoctorRetentionInfo } from "../../service/doctor-retention";

export default function DoctorRetention() {
    const [doctorRetentionData, setDoctorRetentionData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [filter, setFilter] = useState(2);
    const [format, setFormat] = useState(2);

    useEffect(() => {
        getDoctorRetentionData();
    }, [filter, format]);

    const getDoctorRetentionData = async () => {
        try {
            setIsLoading(true);
            const response = await getDoctorRetentionInfo(filter, format)
            if (response.status === 200) {
                setDoctorRetentionData(response?.data?.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return isLoading ? (
        <Loader />
    ) : (
        <div className="doctor-retention-container">
            <div className="dashboard-header">
                <div className="dashboard-title">Doctor Retention Dashboard</div>
                <div className="filter-container">
                    <div
                        className={`filter-option ${filter === 1 ? "active" : ""}`}
                        onClick={() => setFilter(1)}
                    >
                        Month
                    </div>
                    <div
                        className={`filter-option ${filter === 2 ? "active" : ""}`}
                        onClick={() => setFilter(2)}
                    >
                        Week
                    </div>
                </div>
                <div className="filter-container-number">
                    <div
                        className={`filter-option ${format === 1 ? "active" : ""}`}
                        onClick={() => setFormat(1)}
                    >
                        Percentage
                    </div>
                    <div
                        className={`filter-option ${format === 2 ? "active" : ""}`}
                        onClick={() => setFormat(2)}
                    >
                        Number
                    </div>
                </div>
            </div>

            <div className="table-container">
                <table className="retention-table">
                    <thead>
                        <tr>
                            {doctorRetentionData.length > 0 &&
                                Object.keys(doctorRetentionData[0]).map((key) => (
                                    <th key={key}>{key}</th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>
                        {doctorRetentionData.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {Object.entries(row).map(([key, value], colIndex) => (
                                    <td key={colIndex}>
                                        {key === "week" && typeof value === "string" && !isNaN(Date.parse(value))
                                            ? new Intl.DateTimeFormat("en-GB", {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                            }).format(new Date(value))
                                            :
                                            `${value === null ? 0 : value
                                            }${format === 1 && colIndex > 2 ? "%" : ""}`
                                        }
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
